/*
 * Shared keyboard guard for date inputs across the app: the calendar
 * picker icon stays clickable, but typing / arrow-key edits are blocked.
 * Tab is allowed through so focus can still move off the field.
 */
export function blockManualDateEntry(event: KeyboardEvent): void {
  if (event.key === 'Tab') {
    return;
  }

  event.preventDefault();
}
